/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  ListItem,
  withStyles,
  Grid,
  ListItemSecondaryAction,
  Typography,
  Tooltip,
} from '@material-ui/core'
import { Email, Sms } from '@material-ui/icons'
import Menu from '../Menu'
import { changeTemplateID } from 'actions/template'
import { readTemplate, createTemplate } from 'actions/template'
import { Parser, ProcessNodeDefinitions } from 'html-to-react'
import textObjFn from 'utils/textObjFn'
const Handlebars = require('handlebars')

const parser = new Parser()
var isValidNode = function () {
  return true
}

var processNodeDefinitions = new ProcessNodeDefinitions(React)
var preprocessingInstructions = [
  {
    shouldPreprocessNode: function (node) {
      return Boolean(node.name) && node.name === 'a'
    },
    preprocessNode: function (node) {
      node.attribs = { id: `preprocessed-${node.attribs.id}` }
    },
  },
]
var processingInstructions = [
  {
    // Anything else
    shouldProcessNode: function (node) {
      return true
    },
    processNode: processNodeDefinitions.processDefaultNode,
  },
]

const TemplateListItem = withStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(16),
    // fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginTop: 11,
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryAction: {
    [theme.breakpoints.up('xs')]: {
      paddingRight: 39,
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: 60,
    },
  },
  container: {
    listStyle: 'none',
    borderBottom: '1px solid #adadad',
    borderRight: '1px solid #adadad',
  },
  secondaryActionRoot: {
    [theme.breakpoints.up('xs')]: {
      top: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('md')]: {
      top: 'calc(50% - 24px)',
    },
  },
  info: {
    display: 'inline-block',
    minHeight: 40,
    marginLeft: 75,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 68,
    },
  },
  expandPanelIconInner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  expandPanelIconTypography: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '9px',
    width: 73,
    lineHeight: 1.3,
    marginTop: '-4px',
  },
  expandPanelIcon: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
    position: 'absolute',
    left: 43,
    top: '50%',
    [theme.breakpoints.down('sm')]: {
      // top: 65,
      left: 40,
    },
  },
}))(
  ({
    classes,
    addOrEditPush,
    template,
    entityType,
    changeTemplateID,
    readTemplate,
    createTemplate,
    contact,
    vastuser,
    account,
    preferences,
    assignedNumber,
    onClick,
    isPinned,
  }) => {
    const readAndCreateTemplate = () =>
      new Promise((resolve, reject) => {
        readTemplate(template.id).then(templatePayload => {
          createTemplate({
            ...templatePayload,
            id: undefined,
            name: `${templatePayload.name} duplicate ${new Date(
              Date.now(),
            ).toLocaleString()}`,
          }).then(createTemplatePayload => resolve(createTemplatePayload))
        })
      })

    const textObj = textObjFn({ contact, vastuser, preferences, account })

    let compiledText = ''
    let text = ''

    try {
      compiledText = Handlebars.compile(
        template.Template?.HtmlPart || template.Template?.TextPart || '',
      )
      text = compiledText(textObj)
    } catch (error) {
      console.log(error)
    }

    let html = null

    try {
      html = parser.parseWithInstructions(
        text,
        isValidNode,
        processingInstructions,
        preprocessingInstructions,
      )
    } catch (error) {
      console.log(error)
    }

    return (
      <Tooltip
        title={
          <div
            style={{
              zoom: template.Template?.HtmlPart ? '0.5' : '1',
              maxHeight: 400,
              overflow: 'hidden',
            }}
          >
            {/* <iframe
              title={`TooltipPreviewForTemplateWithID${template?.id}`}
              style={{ width: '100%', height: '100%' }}
            > */}
            {html}
            {/* </iframe> */}
          </div>
        }
      >
        <ListItem
          onClick={
            onClick
              ? () => onClick(template)
              : () => {
                  changeTemplateID(template.id)
                  addOrEditPush(template.id, template?.type || 'email')
                }
          }
          key={`templatesPageListItem${template.id}`}
          button
          classes={{
            container: classes.container,
            secondaryAction: classes.secondaryAction,
          }}
        >
          <div className={classes.expandPanelIcon}>
            {template?.type === 'sms' ? (
              <div className={classes.expandPanelIconInner}>
                <Sms />
                <Typography className={classes.expandPanelIconTypography}>
                  Text Message
                </Typography>
              </div>
            ) : (
              <div className={classes.expandPanelIconInner}>
                <Email />
                <Typography className={classes.expandPanelIconTypography}>
                  Email
                </Typography>
              </div>
            )}
          </div>
          <Grid container className={classes.info}>
            <Grid item md={12} lg={6}>
              <div className={classes.heading}>
                <span className={classes.text}>
                  {isPinned ? '📌 ' : ''}
                  {template.name}
                </span>
              </div>
            </Grid>
          </Grid>
          <ListItemSecondaryAction
          // classes={{ root: classes.secondaryActionRoot }}
          >
            <Menu
              vert
              entityName={template.name}
              entityType={entityType}
              entityID={template.id}
              entitySubtype={template?.type || 'email'}
              addOrEditPush={addOrEditPush}
              readAndCreateTemplate={readAndCreateTemplate}
            />
          </ListItemSecondaryAction>
        </ListItem>
      </Tooltip>
    )
  },
)

export default connect(
  state => {
    const contact = {
      id: 'sample',
      first_name: 'Jane',
      middle_name: 'Emily',
      last_name: 'Doe',
      email: [
        {
          id: 'sample-email',
          address: 'jane.doe@example.com',
          opt_in: true,
          email_type: 'W',
        },
      ],
      phones: [
        {
          id: 'sample-phone',
          number: '+19999999999',
          opt_in: true,
          phone_type: 'M',
        },
      ],
      location: 'Huntingdon Valley, PA',
      notes: 'Such a nice person!',
      vastuser: Object.keys(state.data?.['account/user'] || {})?.[0],
    }

    return {
      contact,
      vastuser: state.data?.['account/user']?.[contact?.vastuser],
      preferences: state.data?.['account/preference']?.preferences,
      account: state.data?.account,
      assignedNumber: Object.values(state.data?.phonenumbers || {})?.find(
        numberObj => numberObj?.vast_user_name === contact?.vastuser,
      )?.phone_number,
    }
  },
  dispatch =>
    bindActionCreators(
      { changeTemplateID, createTemplate, readTemplate },
      dispatch,
    ),
)(TemplateListItem)
